import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";

const InitializeMenu = (contact) => {
  let result = [];
  result.push(
    <Menu.Item key="dashboard">
      <Link to="/samplePage"><i className="icon icon-alert" style={{paddingLeft:"1rem"}} />
        <span>داشبورد</span>
      </Link>
    </Menu.Item>)

  if (contact?.isAdmin||contact?.isEstablishmentAdmin||contact?.isGenExtraMeetingAdmin||contact?.isFinanceOperator) {
    result.push(
      <Menu.Item key="Admin">
        <Link to="/admin"><i className="icon icon-extra-components" style={{paddingLeft:"1rem"}}  />
          <span>مدیریت</span>
        </Link>
      </Menu.Item>)
  }
  if (contact.isRegister) {

   /*  result.push(
      <Menu.Item key="Missing">
        <Link to="/missing"><i className="icon icon-alert" style={{paddingLeft:"1rem"}} />
          <span>آگهی مفقودی</span>
        </Link>
      </Menu.Item>)
    result.push(
      <Menu.Item key="EtcAdvertising">
        <Link to="/etcAdvertising"><i className="icon icon-widgets" style={{paddingLeft:"1rem"}} />
          <span>سایر آگهی</span>
        </Link>
      </Menu.Item>)
    result.push(
      <Menu.Item key="Found">
        <Link to="/found"><i className="icon icon-inbox" style={{paddingLeft:"1rem"}} />
          <span>یافت شده ها</span>
        </Link>
      </Menu.Item>) */
  }
  if (contact.isSupport) {
    result.push(
      <Menu.Item key="Support">
        <Link to="/support"><i className="icon icon-autocomplete" style={{paddingLeft:"1rem"}} />
          <span>پشتیبانی</span>
        </Link>
      </Menu.Item>)
  }
  return result;
}
const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {

  let { navStyle, themeType } = useSelector(({ settings }) => settings);
  let { pathname } = useSelector(({ common }) => common);
  let { contact } = useSelector(({ contact }) => { return contact });
  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  // const getNavStyleSubMenuClass = (navStyle) => {
  //   if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
  //     return "gx-no-header-submenu-popup";
  //   }
  //   return "";
  // };
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];
  return (
    <>
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile />
          <AppsNavigation />
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            style={{ textAlign: "right" }}
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline">
            {
              contact && InitializeMenu(contact)
            }


          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;

